/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import AddressLines from './AddressLines/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Address.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-BkxIm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-BkxIm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-BkxIm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-BkxIm': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Address.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<AddressLines
  viewPath={`${viewPath}/AddressLines`}
/>
</div>
<div
  data-testid="Address.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Address.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}